//@flow

import gql from 'graphql-tag';

const appZapTemplatesQuery = gql`
  query appZapTemplatesQuery($appSlug: String!) {
    appBySlug(slug: $appSlug) {
      id
      slug
      name
      images {
        url_32x32
      }
    }
  }
`;

export default appZapTemplatesQuery;
